"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _atom = _interopRequireDefault(require("./atom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * AtomTree - A structure describing the atoms within an mpeg file
 */
var AtomTree =
/*#__PURE__*/
function () {
  function AtomTree() {
    _classCallCheck(this, AtomTree);

    this.root = [];
  }

  _createClass(AtomTree, [{
    key: "insert",

    /**
     * insert -  Insert an atom into the atom tree at it's appropriate location
     *
     * @param  {Atom} atom An Atom object
     */
    value: function insert(atom) {
      var root = this.root;
      var children = root.flatMap(function (e) {
        return explode(e);
      }).filter(function (e) {
        if (isChild(atom, e)) {
          return e;
        }
      });

      if (children.length == 0) {
        root.push(atom);
      } else {
        var lastChild = children[children.length - 1];
        lastChild.insert(atom);
      }
    }
    /**
     * findAtoms - Find atoms by name
     *
     * @param  {String} atomName The name of all the atoms you want to find
     * @return {Array<Atom>}     An array of atoms with the name searched for
     */

  }, {
    key: "findAtoms",
    value: function findAtoms(atomName) {
      return this.root.flatMap(function (e) {
        return explode(e);
      }).filter(function (e) {
        if (e.name == atomName) {
          return e;
        }
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this.root.length;
    }
  }]);

  return AtomTree;
}();
/**
 * explode - Used to recursively unwrap an Atom's children into a flat array
 *
 * @param  {Atom} atom An Atom object with children
 * @return {Array<Atom>} A 1 dimensional array including an atom and all of it's children (and there children and so forth)
 */


var explode = function explode(atom) {
  if (atom.children) {
    var exploded = atom.children.flatMap(function (x) {
      return explode(x);
    });
    return [atom].concat(exploded);
  } else {
    return [atom];
  }
};
/**
 * isChild - Simple check if an atom is a descendant (direct and otherwise) of a parent atom
 *
 * @param  {Atom} subject The Atom that may be a child
 * @param  {Atom} suspect The Atom that may be the parent
 * @return {Boolean} A bool.  true if the subject falls within the range of the parent
 */


function isChild(subject, suspect) {
  if (subject.location < suspect.location + suspect.size) {
    return true;
  }

  return false;
}

var _default = AtomTree;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/fmp4/atom-tree.js
// module id = 469
// module chunks = 0